import { NavLink } from "react-router-dom";
import { LayoutDashboard, Mail, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";

const Sidebar = ({ onLogout }) => {
  const navItems = [
    { to: "/", icon: LayoutDashboard, label: "Dashboard" },
    { to: "/letters", icon: Mail, label: "Letters" },
  ];

  const username = localStorage.getItem("username") || "Admin";

  return (
    <aside className="sidebar" data-testid="sidebar">
      <div className="p-6">
        <h1 className="font-heading text-lg font-bold text-blue-900 tracking-tight leading-tight">
          Area 47 SDA
        </h1>
        <p className="text-xs text-slate-500 mt-1 font-body">Church Letter Management</p>
      </div>

      <nav className="mt-6 px-3 flex-1">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            data-testid={`nav-${item.label.toLowerCase()}`}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-lg mb-1 transition-all duration-200 font-body text-sm font-medium ${
                isActive ? "bg-blue-900 text-white" : "text-slate-600 hover:bg-slate-100"
              }`
            }
          >
            <item.icon size={20} />
            <span className="sidebar-text">{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="p-4 border-t border-slate-100 mt-auto">
        <div className="flex items-center justify-between mb-3 px-2">
          <span className="text-sm text-slate-600 font-body font-medium">{username}</span>
        </div>
        <Button
          variant="outline"
          onClick={onLogout}
          className="w-full justify-start gap-2 text-slate-600 hover:text-red-600 hover:bg-red-50 hover:border-red-200"
          data-testid="logout-btn"
        >
          <LogOut size={18} />
          <span className="sidebar-text">Logout</span>
        </Button>
      </div>
    </aside>
  );
};

export default Sidebar;
